import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.page.html',
  styleUrls: ['./splash.page.scss'],
})
export class SplashPage implements OnInit {

  animate = false;

  constructor(private router: Router) { }

  ngOnInit() {
    this.animate = true;
    // console.log('SPLASH START -> ', new Date().getSeconds());
    this.awaitMe().then((result: boolean) => {
      // console.log('SPLASH END -> ', new Date().getSeconds());
      this.router.navigate(['/home']);
      this.animate = false;
    });
  }

  async awaitMe() {
    return new Promise((resolve) => {
      const ms = (environment.splashScreenDuration * 1000);
      const t = setTimeout(() => {
        resolve(true);
        console.log('avaitMe END');
        clearTimeout(t);
      }, ms);
    });
  }

}
